import { render, staticRenderFns } from "./ForecastMix.vue?vue&type=template&id=52d087b6&scoped=true&"
import script from "./ForecastMix.vue?vue&type=script&lang=ts&"
export * from "./ForecastMix.vue?vue&type=script&lang=ts&"
import style0 from "./ForecastMix.vue?vue&type=style&index=0&id=52d087b6&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d087b6",
  null
  
)

export default component.exports